var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-header"},[_c('div',{staticClass:"logo",class:{ 'logo-left': _vm.position === 'left' },on:{"click":_vm.goHome}},[_vm._v("\n\t\tCognitive Cloud\n\t")]),(!_vm.noSep)?_c('div',{staticClass:"sep"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }